import { TbReportMoney } from 'react-icons/tb'
import { Navigate, useLocation } from 'react-router-dom'

import { REPORT_LIST, reportUrl } from '../Configs/reportList'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

export const REPORTS_TITLE = 'Звіти'

/**
 * «Звіти» (`SPEC-027` §3.4): пункт меню веде сюди, а сторінка одразу відкриває
 * перший звіт. Окремий перелік із пошуком (як `ReportIndexPage.jsx` легасі)
 * прибрано за рішенням замовника 2026-10-22: між трьома звітами й так
 * перемикають вкладки над таблицею.
 *
 * Параметри адреси (`?from=&to=`) переносимо: посилання на «Звіти» з періодом
 * має відкрити звіт за тим самим періодом.
 */
const IndexPage = () => {
    const { search } = useLocation()

    return <Navigate replace to={`${reportUrl(REPORT_LIST[0]!)}${search}`} />
}

export default IndexPage

export const pageConfig: IPageConfig = {
    key: 'Report.Index',
    route: '/report',
    title: REPORTS_TITLE,
    icon: <TbReportMoney />,
}
